<script setup>
  import {onMounted, ref, watch} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import {MedButton, MedSpinner} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "CryptDialogsEducation",
  });

  const props = defineProps({
    privacy: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    logout: {
      type: Function,
      required: true,
    },
  });

  const educationPassword = "Holleri du dödel di diri diri dudel dö!";

  const refCryptDialog = ref(null);

  watch(
    () => props.isLoading,
    (newValue) => {
      // only a successful run closes the dialog: setPassword() ends its error
      // path with isLoading === false as well, and there the dialog has to
      // stay open to name the problem - it switches to VERIFICATION_INVALID,
      // which points to the support and disables OK (MED-12871)
      if (newValue === false && props.privacy.hasCryptStatus("VERIFICATION_VALID")) {
        close();
      }
    },
  );

  onMounted(() => {
    props.privacy.setCurrentStatus("ENCRYPTION_NOT_SET");
    props.privacy.plaintextPassword(educationPassword);
  });

  const open = () => {
    refCryptDialog.value.open();
  };

  const close = () => {
    if (refCryptDialog.value) refCryptDialog.value.close();
  };

  const continueWithoutPrivacyPassword = () => {
    if (props.privacy.hasCryptStatus("ENCRYPTION_NOT_SET") || props.privacy.hasCryptStatus("ENCRYPTION_INVALID")) {
      props.privacy.setRecoveryCodeHasBeenPrinted(true);
      props.privacy.setPassword();
    } else if (props.privacy.hasCryptStatus("VERIFICATION_PENDING")) {
      props.privacy.verifyPassword(
        () => {
          props.privacy.initCrypt();
          props.privacy.setEncryptLocalStorage(true);
          props.privacy.setCurrentStatus("VERIFICATION_VALID");
          close();
        },
        () => {
          props.privacy.setCurrentStatus("VERIFICATION_INVALID");
        },
      );
    }
  };

  defineExpose({
    open,
    close,
  });
</script>

<template>
  <ComponentDialog ref="refCryptDialog" dialog-width="medium" :test-id="getTestId('education')">
    <template #title>
      <span v-if="privacy.hasCryptStatus('VERIFICATION_INVALID')">
        Beim Startvorgang für die Verarbeitung fiktiver Fälle ist ein Fehler aufgetreten
      </span>

      <span v-else>Hinweis zu Ihrer MediCheck-Version</span>
    </template>

    <template #content>
      <p>
        <template v-if="isLoading">
          <div class="text-center">
            <MedSpinner size="3xl" :data-test="getTestId('education-dialog-spinner')" />
          </div>
        </template>

        <template v-else>
          <template v-if="privacy.hasCryptStatus('VERIFICATION_INVALID')">
            Bitte melden Sie sich bei unserem Support und teilen dort mit, dass Sie eine
            <strong>eingeschränkte Version</strong>
            des MediCheck nutzen und ein
            <strong>Problem bei der Initialisierung der Verschlüsselung</strong>
            aufgetreten ist.
          </template>

          <template v-else>
            Sie verwenden eine Version des MediCheck, in der
            <strong>nur fiktive</strong>
            bzw. anonymisierte oder didaktische
            <strong>und zu Lehr- bzw. Ausbildungszwecken</strong>
            konzipierte oder
            <strong>modifizierte Fälle</strong>
            bearbeitet werden dürfen.
          </template>
        </template>
      </p>
    </template>

    <template #actions>
      <MedButton
        variant="primary"
        :disabled="isLoading || privacy.hasCryptStatus('VERIFICATION_INVALID')"
        :data-test="getTestId('education-dialog-continue-without-privacy-password-button')"
        @click="continueWithoutPrivacyPassword()"
      >
        OK
      </MedButton>

      <MedButton flat variant="primary" :data-test="getTestId('education-dialog-logout-button')" @click="logout">
        Abmelden
      </MedButton>
    </template>
  </ComponentDialog>
</template>
